import { Journey } from '../../types'

export default function (parameterName: string, journey: Journey) {
  const [form] = journey.journeyPages
  const questions = form.pageQuestions.map(
    ({ questionParameterId, dependentQuestionParameterId, questionParameterName }) => {
      return {
        questionParameterId,
        dependentQuestionParameterId,
        questionParameterName,
      }
    },
  )

  const changedField = questions.find(({ questionParameterName }) => questionParameterName === parameterName)

  if (!changedField || !changedField.dependentQuestionParameterId) {
    return
  }

  const dependentQuestion = questions.find(
    ({ questionParameterId }) => questionParameterId === changedField.dependentQuestionParameterId,
  )

  return dependentQuestion!.questionParameterName
}
